// @ts-nocheck
/* eslint-disable */
import { _ } from "~/route/globals";

/**
 * @class Polozka kontextoveho menu menu prujezdniho bodu pro jeho odebrani
 */
export const MapContextItem = function(ind) {
	SMap.Control.ContextMenu.Item.call(this, _("route.form.contextItem.title"));
	this._ind = ind;
};

MapContextItem.prototype = Object.create(Object.assign({}, SMap.Control.ContextMenu.Item.prototype));

MapContextItem.prototype.click = function(e, menu) {
	if (this._disabled) {
		return;
	}

	let items = Mapy.CML.state.route.items;
	items.splice(this._ind, 1);

	if (items.length == 1) {
		if (!items[0].tripData) {
			items[0].tripData = [];
		}

		if (!items[0].path) {
			items[0].path = [];
		}

		items[0].path[Mapy.CML.state.route.index] = "";
	}

	Mapy.CML.state = {
		route: {
			items,
			...items.length < 2 ? {
				responseData: [],
			} : {},
		}
	};
	menu.close();

	Mapy.getComponent("history").save();
};
